import {
  Button,
  Form,
  FormInstance,
  Input,
  Modal,
  Select,
  Space,
  Switch,
  Tooltip,
} from 'antd';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { RemoveButton } from '../../../../Components/Buttons/RemoveButton';
import { S7Module } from '../../../../Models/PlatformManager/S7Module';
import { DataTransferMethod } from '../../../../Enums/DataTransferMethod';

export function AddS7ModuleForm(props: {
  allData?: S7Module[];
  data?: S7Module;
  open: boolean;
  onCancel: Function;
  onSafe: Function;
  onRemove: Function;
  onEdit: boolean;
}) {
  const [form] = Form.useForm();

  const { i18n, t } = useTranslation();

  const [removeItem, setRemoveItem] = useState(false);
  const [logoModule, setLogoModule] = useState<S7Module>();

  useEffect(() => {
    form.resetFields();
    setLogoModule(props.data);
    setRemoveItem(false);
  }, [form, props.data, logoModule]);

  const handleCancel = () => {
    props.onCancel();
  };

  const onFinishForm = (values: S7Module) => {
    if (props.data?.id !== undefined) {
      values.id = props.data?.id;
    }
    if (props.data?.idPlatform !== undefined) {
      values.idPlatform = props.data?.idPlatform;
    }
    if (props.data?.idUnit !== undefined) {
      values.idUnit = props.data?.idUnit;
    }
    if (props.data?.isOnline !== undefined) {
      values.isOnline = props.data?.isOnline;
    }

    if (removeItem) {
      props.onRemove(values);
    } else {
      props.onSafe(values);
    }
  };

  const onFinishFormFailed = (errorInfo: any) => {};

  const checkLabelExist = (_: any, value: string) => {
    var foundItem = props.allData?.find((x) => x.name === value);
    if (foundItem !== undefined) {
      if (foundItem.id === props.data?.id) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('Deze naam bestaat al'));
    }
    return Promise.resolve();
  };

  const isValidIPv4 = (_: any, value: string) => {
    const ipv4Regex =
      /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
    var result = ipv4Regex.test(value);
    if (result) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Dit IP formaat is niet geldig'));
  };

  const RenderRemoveButton = () => {
    if (logoModule?.id) {
      return (
        <RemoveButton
          disabled={false}
          textBtn={t('remove')}
          bindedFunction={setRemoveItem}
          bindedForm={form}
        ></RemoveButton>
      );
    }
    return <></>;
  };

  const GetDataTraferMethod = () => {
    return [
      { value: DataTransferMethod.S7Client, label: 'S7Client' },
      { value: DataTransferMethod.S7Net, label: 'S7.Net' },
      { value: DataTransferMethod.OpcUa, label: 'OpcUa' },
      { value: DataTransferMethod.Modbus, label: 'Modbus' },
    ];
  };

  return (
    <Modal
      title={t('adds7module')}
      open={props.open}
      onOk={() => form.submit()}
      okText={t('safe')}
      cancelText={t('cancel')}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          {t('cancel')}
        </Button>,
        <>
          {RenderRemoveButton()}

          <Button key="submit" type="primary" onClick={() => form.submit()}>
            {t('safe')}
          </Button>
        </>,
      ]}
    >
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={props.data}
        onFinish={onFinishForm}
        onFinishFailed={onFinishFormFailed}
        autoComplete="off"
        form={form}
      >
        <Form.Item
          label={t('name')}
          name="name"
          key="name"
          required
          rules={[
            {
              required: true,
              message: t('fillfield').toString(),
            },
            { validator: checkLabelExist },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('moduleId')}
          name="moduleId"
          key="moduleId"
          rules={[{ required: true, message: t('fillfield').toString() }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('enabled')}
          name="enabled"
          key="enabled"
          valuePropName="checked"
          rules={[{ required: true, message: t('fillfield').toString() }]}
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label={t('ipaddress')}
          name="ipAddress"
          key="ipAddress"
          rules={[
            { required: true, message: t('fillfield').toString() },
            { validator: isValidIPv4 },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('dataTransferMethod')}
          name="dataTransferMethod"
          key="dataTransferMethod"
          rules={[{ required: true, message: t('selectanoption').toString() }]}
        >
          <Select options={GetDataTraferMethod()}>
            <Select.Option value="demo">Demo</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label={t('hideStyle')}
          name="hideStyle"
          valuePropName="checked"
          rules={[{ required: true, message: t('fillsocketkey').toString() }]}
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label={t('styleIsOnline')}
          name="styleIsOnline"
          rules={[{ required: true, message: t('fillsocketkey').toString() }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}
